export interface Direction {
  name: string;
  sanskrit: string;
  english: string;
  degrees: number;
  prohibitedDays: string[];
  remedies: string[];
  description: string;
}

export interface DayInfo {
  name: string;
  englishName: string;
  prohibitedDirection: string;
  description: string;
  remedies: string[];
  special: string;
}

export const directions: Direction[] = [
  {
    name: "पूर्व",
    sanskrit: "Purva",
    english: "East",
    degrees: 90,
    prohibitedDays: ["सोमवार", "शनिवार"],
    remedies: [
      "सोमवार को दर्पण देखकर या पुष्प खाकर और शनिवार को अदरक, उड़द या तिल खाकर घर से बाहर निकलें। इससे पहले पांच कदम उल्टे पैर चलें।"
    ],
    description: "सोमवार और शनिवार को पूर्व दिशा की यात्रा वर्जित मानी गई है, इस दिन पूर्व दिशा में दिशा शूल रहता है।  "
  },
  {
    name: "पश्चिम",
    sanskrit: "Paschim",
    english: "West",
    degrees: 270,
    prohibitedDays: ["रविवार", "शुक्रवार"],
    remedies: [
      "रविवार को दलिया, घी या पान खाकर और शुक्रवार को जौ या राईं खाकर घर से बाहर निकलें, इससे पहले पांच कदम पीछे चलें।"
    ],
    description: "रविवार और शुक्रवार को पश्चिम दिशा की यात्रा वर्जित मानी गई है, इस दिन पश्चिम दिशा में दिशा शूल रहता है।"
  },
  {
    name: "उत्तर",
    sanskrit: "Uttar",
    english: "North",
    degrees: 0,
    prohibitedDays: ["मंगलवार", "बुधवार"],
    remedies: [
      "मंगलवार को गुड़ खाकर और बुधवार को तिल, धनिया खाकर घर से बाहर निकलें, इससे पहले पांच कदम पीछे चलें।"
    ],
    description: "मंगलवार और बुधवार को उत्तर दिशा की यात्रा वर्जित मानी गई है, इस दिन उत्तर दिशा में दिशा शूल रहता है।"
  },
  {
    name: "दक्षिण",
    sanskrit: "Dakshin",
    english: "South",
    degrees: 180,
    prohibitedDays: ["गुरुवार"],
    remedies: ["गुरुवार को दहीं या जीरा खाकर घर से बाहर निकलें, इससे पहले पांच कदम पीछे चलें।"],
    description: "गुरुवार को दक्षिण दिशा की यात्रा वर्जित मानी गई है, इस दिन दक्षिण दिशा में दिशा शूल रहता है। "
  },
  {
    name: "आग्नेय",
    sanskrit: "Agneya",
    english: "Southeast",
    degrees: 135,
    prohibitedDays: ["सोमवार", "गुरुवार"],
    remedies: [
      "सोमवार को दर्पण देखकर, गुरुवार को दहीं या जीरा खाकर घर से बाहर निकलें, इससे पहले पांच कदम पीछे चलें।"
    ],
    description: "सोमवार और गुरुवार को दक्षिण-पूर्व (आग्नेय) दिशा की यात्रा वर्जित मानी गई है, इस दिन इस दिशा में दिशा शूल रहता है।"
  },
  {
    name: "नैऋत्य",
    sanskrit: "Nairutya",
    english: "Southwest",
    degrees: 225,
    prohibitedDays: ["रविवार", "शुक्रवार"],
    remedies: [
      "रविवार को दलिया और घी खाकर और शुक्रवार को जौ खाकर घर से बाहर निकलें, इससे पहले पांच कदम पीछे चलें।"
    ],
    description: "रविवार और शुक्रवार को दक्षिण-पश्चिम (नैऋत्य) दिशा की यात्रा वर्जित मानी गई है, इस दिन इस दिशा में दिशा शूल रहता है।"
  },
  {
    name: "वायव्य",
    sanskrit: "Vayavya",
    english: "Northwest",
    degrees: 315,
    prohibitedDays: ["मंगलवार"],
    remedies: ["मंगलवार को गुड़ खाकर घर से बाहर निकलें, इससे पहले पांच कदम पीछे चलें।"],
    description: "मंगलवार को उत्तर-पश्चिम (वायव्य) दिशा की यात्रा वर्जित मानी गई है। इस दिन इस दिशा में दिशा शूल रहता है।"
  },
  {
    name: "ईशान",
    sanskrit: "Ishan",
    english: "Northeast",
    degrees: 45,
    prohibitedDays: ["बुधवार", "शनिवार"],
    remedies: [
      "बुधवार को तिल या धनिया खाकर और शनिवार को अदरक, उड़द की दाल या तिल खाकर घर से बाहर निकलें, इससे पहले पांच कदम पीछे चलें।"
    ],
    description: "बुधवार और शनिवार को उत्तर-पूर्व (ईशान) दिशा की यात्रा वर्जित मानी गई है, इस दिन इस दिशा में दिशाशूल रहता है।"
  }
];

export const dailyInfo: Record<string, DayInfo> = {
  "रविवार": {
    name: "रविवार",
    englishName: "Sunday",
    prohibitedDirection: "पश्चिम",
    description: "रविवार को पश्चिम दिशा की यात्रा वर्जित मानी गई है, इस दिन पश्‍चिम दिशा में दिशा शूल रहता है।",
    remedies: ["रविवार को दलिया, घी या पान खाकर घर से बाहर निकलें, इससे पहले पांच कदम पीछे चलें।"],
    special: "यदि एक जगह से रवाना हो कर उसी दिन गंतव्य स्थान पर पहुंचं जाना तय हो तो ऐसी यात्रा में तिथि- वार नक्षत्र, दिशा-शूल, प्रतिशुक, योगनी आदि का विचार नहीं होता है।"
  },
  "सोमवार": {
    name: "सोमवार",
    englishName: "Monday",
    prohibitedDirection: "आग्नेय",
    description: "सोमवार को दक्षिण-पूर्व (आग्नेय) दिशा की यात्रा वर्जित मानी गई है, इस दिन पूर्व दिशा में दिशा शूल रहता है।",
    remedies: ["सोमवार को दर्पण देखकर या पुष्प खाकर घर से बाहर निकलें, इससे पहले पांच कदम उल्टे पैर चलें।"],
    special: "यदि एक जगह से रवाना हो कर उसी दिन गंतव्य स्थान पर पहुंचं जाना तय हो तो ऐसी यात्रा में तिथि- वार नक्षत्र, दिशा-शूल, प्रतिशुक, योगनी आदि का विचार नहीं होता है।"
  },
  "मंगलवार": {
    name: "मंगलवार",
    englishName: "Tuesday",
    prohibitedDirection: "वायव्य",
    description: "मंगलवार को उत्तर-पश्चिम (वायव्य) दिशा की यात्रा वर्जित मानी गई है, इस दिन इस दिशा में दिशा शूल रहता है।",
    remedies: ["मंगलवार को गुड़ खाकर घर से बाहर निकलें, इससे पहले पांच कदम पीछे चलें।"],
    special: "यदि एक जगह से रवाना हो कर उसी दिन गंतव्य स्थान पर पहुंचं जाना तय हो तो ऐसी यात्रा में तिथि- वार नक्षत्र, दिशा-शूल, प्रतिशुक, योगनी आदि का विचार नहीं होता है।"
  },
  "बुधवार": {
    name: "बुधवार",
    englishName: "Wednesday",
    prohibitedDirection: "उत्तर",
    description: "बुधवार को उत्तर दिशा की यात्रा वर्जित मानी गई है, इस दिन उत्तर दिशा में दिशा शूल रहता है।",
    remedies: ["बुधवार को तिल या धनिया खाकर घर से बाहर निकलें, इससे पहले पांच कदम पीछे चलें।"],
    special: "यदि एक जगह से रवाना हो कर उसी दिन गंतव्य स्थान पर पहुंचं जाना तय हो तो ऐसी यात्रा में तिथि- वार नक्षत्र, दिशा-शूल, प्रतिशुक, योगनी आदि का विचार नहीं होता है।"
  },
  "गुरुवार": {
    name: "गुरुवार",
    englishName: "Thursday",
    prohibitedDirection: "दक्षिण",
    description: "गुरुवार को दक्षिण दिशा की यात्रा वर्जित मानी गई है, इस दिन दक्षिण दिशा में दिशा शूल रहता है।",
    remedies: ["गुरुवार को दहीं या जीरा खाकर घर से बाहर निकलें, इससे पहले पांच कदम पीछे चलें।"],
    special: "यदि एक जगह से रवाना हो कर उसी दिन गंतव्य स्थान पर पहुंचं जाना तय हो तो ऐसी यात्रा में तिथि- वार नक्षत्र, दिशा-शूल, प्रतिशुक, योगनी आदि का विचार नहीं होता है।"
  },
  "शुक्रवार": {
    name: "शुक्रवार",
    englishName: "Friday",
    prohibitedDirection: "नैऋत्य",
    description: "शुक्रवार को दक्षिण-पश्चिम (नैऋत्य) दिशा की यात्रा वर्जित मानी गई है, इस दिन इस दिशा में दिशा शूल रहता है।",
    remedies: ["शुक्रवार को जौ खाकर घर से बाहर निकलें, इससे पहले पांच कदम पीछे चलें।"],
    special: "यदि एक जगह से रवाना हो कर उसी दिन गंतव्य स्थान पर पहुंचं जाना तय हो तो ऐसी यात्रा में तिथि- वार नक्षत्र, दिशा-शूल, प्रतिशुक, योगनी आदि का विचार नहीं होता है।"
  },
  "शनिवार": {
    name: "शनिवार",
    englishName: "Saturday",
    prohibitedDirection: "ईशान",
    description: "शनिवार को उत्तर-पूर्व (ईशान) दिशा की यात्रा वर्जित मानी गई है, इस दिन इस दिशा में दिशाशूल रहता है।",
    remedies: ["शनिवार को अदरक, उड़द की दाल या तिल खाकर घर से बाहर निकलें, इससे पहले पांच कदम पीछे चलें।"],
    special: "यदि एक जगह से रवाना हो कर उसी दिन गंतव्य स्थान पर पहुंचं जाना तय हो तो ऐसी यात्रा में तिथि- वार नक्षत्र, दिशा-शूल, प्रतिशुक, योगनी आदि का विचार नहीं होता है।"
  }
};

export const weekDays = [
  "रविवार",
  "सोमवार",
  "मंगलवार",
  "बुधवार",
  "गुरुवार",
  "शुक्रवार",
  "शनिवार"
];

export const getProhibitedDirectionsForDay = (day: string): Direction[] => {
  return directions.filter(direction => direction.prohibitedDays.includes(day));
};

export const getDailyInfo = (day: string): DayInfo => {
  return dailyInfo[day];
};